import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxSelectBoxComponent,
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import { SupplierDto, SupplierStatus } from '@services';
import EnumUtils from '../../../../shared/enum-utils';

@Component({
    selector: 'supplier-form',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxSelectBoxComponent
    ],
    templateUrl: './supplier-form.component.html',
})
export class SupplierFormComponent {
    @Input() isReadOnly: boolean = false;
    @Input() data: SupplierDto = {
        status: SupplierStatus.Active,
    } as SupplierDto;

    supplierStatusOptions = EnumUtils.getEnumOptions(SupplierStatus);

    getSizeQualifier = getSizeQualifier;

    getData = () => ({ ...this.data }) as SupplierDto;
}
